import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-audio-player',
  templateUrl: './mini-audio-player.component.html',
  styleUrl: './mini-audio-player.component.scss'
})
export class MiniAudioPlayerComponent implements OnInit, OnDestroy {
  @Input() src!: string;

  private audio!: HTMLAudioElement;
  isPlaying = false;
  duration = 0;
  currentTime = 0;

  ngOnInit(): void {
    this.audio = new Audio(this.src);
    this.audio.preload = 'metadata';

    this.audio.addEventListener('loadedmetadata', () => {
      this.duration = this.audio.duration;
    });

    this.audio.addEventListener('timeupdate', () => {
      this.currentTime = this.audio.currentTime;
    });

    this.audio.addEventListener('ended', () => {
      this.isPlaying = false;
      this.currentTime = 0;
    });
  }

  togglePlay(): void {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play();
      this.isPlaying = true;
    }
  }

  get displayTime(): string {
    const time = this.isPlaying || this.currentTime > 0 ? this.currentTime : this.duration;
    if (!time || isNaN(time)) return '--:--';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  ngOnDestroy(): void {
    this.audio.pause();
    this.audio.src = '';
  }
}
